export const statusList = [
  {
    label: "Active",
    value: "active",
    className: "bg-[#1DB4691F] text-[#11A75C]",
  },
  {
    label: "Inactive",
    value: "inactive",
    className: "bg-[#FFF5F4] text-[#FF3838]",
  },
];
